import React, { useState, useEffect } from 'react';
import {
  TextField,
  Box,
  Tabs,
  Tab,
  
} from '@mui/material';
import MainCard from 'components/MainCard';
import PoseDetectionError from 'components/systemMonitoring/PoseDetectionError';
import StorageUsage from 'components/systemMonitoring/StorageUsage';
import AIInference from 'components/systemMonitoring/AIInference';

export default function SystemMonitoring() {
  const [searchTerm, setSearchTerm] = useState('');
  const [tabValue, setTabValue] = useState(0);
 

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let DisplayComponent;
  if(tabValue === 0){
{
    DisplayComponent = <PoseDetectionError/>
}
  }else if(tabValue === 1){
    {
    DisplayComponent = <StorageUsage/>
}
   }else if(tabValue === 2){
    {
    DisplayComponent = <AIInference/>
}
   } 

  return (
    <MainCard>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Pose Detection Error Logs"  iconPosition="end" />
          <Tab label="Storage Usage Metrics"  iconPosition="end" />
          <Tab label="AI Inference Response Times"  iconPosition="end" />
        </Tabs>
        {/* <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField label="Search Coach" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
         
        </Box> */}
      </Box>     
{
    DisplayComponent
}
     
    </MainCard>
  );
}
